import { createFileRoute, Outlet } from "@tanstack/react-router"

import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/vehicles"
)({
  staticData: {
    pageName: "Vehicles",
  },
  component: Outlet,
  loader: () => {
    return {
      crumb: { translationKey: "common:account.vehicles.header" } as Crumb,
    }
  },
})
